webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(14)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(5),
  /* template */
  __webpack_require__(28),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_App_styl__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_App_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_App_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TagplayWidget_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TagplayWidget_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_TagplayWidget_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SiteHeader_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SiteHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_SiteHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Winners_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Winners_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Winners_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: { TagplayWidget: __WEBPACK_IMPORTED_MODULE_1__components_TagplayWidget_vue___default.a, SiteHeader: __WEBPACK_IMPORTED_MODULE_2__components_SiteHeader_vue___default.a, Winners: __WEBPACK_IMPORTED_MODULE_3__components_Winners_vue___default.a }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'siteHeader'
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_TagplayCustom_styl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_TagplayCustom_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_TagplayCustom_styl__);
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['cols'],
  name: 'taplayWidget',
  mounted: function mounted() {
    var widgetElement = document.getElementById('tagplay-widget-1c6bd9');
    if (typeof TagplayWidget === 'function') {
      TagplayWidget(widgetElement);
    } else {
      if (!window.tagplayWidgetQueue) window.tagplayWidgetQueue = [];
      window.tagplayWidgetQueue.push(widgetElement);
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_TagplayCustom_styl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_TagplayCustom_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_TagplayCustom_styl__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      posts: [{
        name: 'Jón Óskar Hauksson',
        username: 'jonoskarhauksson',
        prize: 'Flug fyrir tvo til Evrópu með Wow-air',
        post: 'BYgz8qxFC9y'
      }, {
        name: 'Anna María Axelsdóttir',
        username: 'annamariaaxels',
        prize: 'Premiumferð fyrir tvo í Bláa Lónið og óvissuferð á veitingastaðnum Lava fyrir tvo.',
        post: 'BIW9ESGDG2z'
      }, {
        name: 'Rúnar Muccio',
        username: 'rgmuccio',
        prize: 'Gisting fyrir tvo á Hótel Keflavík',
        post: 'BYVTckcjv2h'
      }, {
        name: 'Arnþór Guðmundsson',
        username: 'addi_gum',
        prize: 'Út að borða fyrir tvo á Fish House Grindavík.',
        post: 'BXbS04zlI_a'
      }, {
        name: 'Jón Óskar Hauksson',
        username: 'jonoskarhauksson',
        prize: 'Hádegismatur fyrir tvo Hjá Höllu í Grindavík.',
        post: 'BYg00NuFXOd'
      }, {
        name: 'Alla Ásmundsdóttir',
        username: 'allaasmunds',
        prize: 'Hvalaskoðun eða sjóstöng fyrir allt að fimm manns með Whale Watching Reykjanes.',
        post: 'BYdkwBXjad2'
      }, {
        name: 'Bjarni Lúðvíksson',
        username: 'bjarniludviksson',
        prize: 'Gisting fyrir tvo á Light House Inn í Svartsengi.',
        post: 'BC58v10jVr9'
      }, {
        name: 'Marvin Ingi Einarsson',
        username: 'marvineinars',
        prize: 'Árskort í Víkingaheima.',
        post: 'BWN3hk7lBRD'
      }, {
        name: 'Marvin Ingi Einarsson',
        username: 'marvineinars',
        prize: 'Sundkort í Grindavík.',
        post: 'Pmxy4eqz2i'
      }, {
        name: 'Eygló',
        username: 'epplapie',
        prize: 'Ferð fyrir tvo um Reykjanes með Gateway to Iceland.',
        post: 'BToD-u_FtCN'
      }]
    };
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_carousel__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_carousel__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_carousel___default.a);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 10 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 11 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"header":"ICR08Si8EQHzFmyuhjrAf","header__inner":"_26EbiZGl0Gp2f0rJaWnaCL","header__logo":"_14E2HLc9-Jdws4oSsWWDaW"};

/***/ }),
/* 12 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tagplayContainer":"_3pcLp0lIAqC3VKdKvyi6L","columns":"_1zNX4YqKNVL2Evku8XukuJ","column":"_3nY5v2tVc0PVT9vyR7jyQd"};

/***/ }),
/* 13 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tagplayContainer":"_3pcLp0lIAqC3VKdKvyi6L","columns":"_1zNX4YqKNVL2Evku8XukuJ","column":"_3nY5v2tVc0PVT9vyR7jyQd"};

/***/ }),
/* 14 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"list":"_3KHyh0HGlodppXvlGX_d_u_0","title":"_382G7D5iOAm8HW1HVDbUOc_0","titleLarge":"_1F9HOaBCNOjHMyi_szRyLD_0","titleSmall":"mQXcyQsbgNdGkwKx5OcFf_0","text":"_2AEnERwPcrhFUHTLuywUCH_0","sliderText":"_5guXx8iHP5ppj-4XaRWQS_0","prizeText":"UjC35O-2sujsSCedBo9AK_0","slide":"_2U9MDXbEmLs2tayR8rv21j_0","tag":"_3YVHJSA3sECJB6DgiwTpKe_0","gridContainer":"_1a8exlWPTUq5cKa1jNeBcQ_0","fullCol":"jOGM_P62LzUBtNNCMXh5I_0","twoCol":"_3HBRMVvjadbqsBhN0XVFUd_0","oneCol":"_1nNQaX9v7iafWdrzm30hMc_0","col":"_2dXEKbxlKWqxw8kK9-a3nm_0","col__places":"BYT_uPksuaZWeasX31bNj_0"};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bluelagoon.c93cd53.jpg";

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.6b7082a.png";

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/slider1.ce11cbd.jpg";

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/slider2.e99c5f6.jpg";

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/slider3.3f9a1a4.jpg";

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/slider4.a9f058e.jpg";

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/slider5.4c40624.jpg";

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/slider6.cf520cc.jpg";

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/slider7.85e5685.jpg";

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wow.399f32f.png";

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(11)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(6),
  /* template */
  __webpack_require__(29),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(13)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(7),
  /* template */
  __webpack_require__(31),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(12)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(8),
  /* template */
  __webpack_require__(30),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('site-header'), _vm._v(" "), _c('div', {
    class: _vm.$style.gridContainer
  }, [_c('div', {
    class: [_vm.$style.col, _vm.$style.oneCol],
    staticStyle: {
      "display": "none"
    }
  }, [_c('h2', {
    class: _vm.$style.title
  }, [_vm._v("Vinningar")]), _vm._v(" "), _c('p', {
    class: _vm.$style.text
  }, [_c('carousel', {
    attrs: {
      "perPage": 1,
      "autoplay": true
    }
  }, [_c('slide', {
    class: _vm.$style.slide
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(24),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    class: [_vm.$style.sliderText, _vm.$style.prizeText]
  }, [_c('strong', [_vm._v("WOW air")]), _vm._v(" - Flug fyrir tvo til Evrópu\n              ")])]), _vm._v(" "), _c('slide', {
    class: _vm.$style.slide
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(15),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    class: [_vm.$style.sliderText, _vm.$style.prizeText]
  }, [_c('strong', [_vm._v("Bláa Lónið")]), _vm._v(" fyrir tvo og út að borða á "), _c('strong', [_vm._v("Lava Restaurant")])])])], 1)], 1)]), _vm._v(" "), _c('div', {
    class: [_vm.$style.col, _vm.$style.twoCol]
  }, [_c('h2', {
    class: _vm.$style.title
  }, [_vm._v("Myndaleikur")]), _vm._v(" "), _c('h3', {
    class: [_vm.$style.title, _vm.$style.titleSmall]
  }, [_vm._v("Ef þú tekur ekki mynd, þá gerðist það ekki!")]), _vm._v(" "), _c('p', {
    class: _vm.$style.text
  }, [_vm._v("\n\n        Á fimmta hundrað myndir bárust í myndaleikinn Við höfum góða sögu að segja sem fram fór í sumar.\n        Þátttakendur þurftu að smella myndum af á Reykjanesi og birta á samfélagsmiðlum undir myllumerkinu #godarsogur.\n        Glæsilegir vinningar voru í boði en trompvinningurinn var flugferð fyrir tvo til Evrópu með WOW.\n\n      ")]), _vm._v(" "), _c('p', {
    class: _vm.$style.text
  }, [_vm._v("\n\n        Jón Óskar Hauksson, formaður Ljósops – áhugaljósmyndarafélags Suðurnesja, fékk trompvinningin fyrir fimm frábærar myndir af Reykjanesi.\n        Lista yfir vinningshafa má sjá hér að neðan en þeir geta nálgast vinningana í Hljómahöllinni í Reykjanesbæ.\n\n      ")]), _vm._v(" "), _c('p', {
    class: _vm.$style.text
  }, [_vm._v("\n\n        Við þökkum kærlega fyrir þátttökuna.\n\n      ")])]), _vm._v(" "), _c('div', {
    class: [_vm.$style.col, _vm.$style.oneCol]
  }, [_c('h2', {
    class: _vm.$style.title
  }, [_vm._v("Vissir þú að...")]), _vm._v(" "), _c('p', {
    class: _vm.$style.text
  }, [_c('carousel', {
    attrs: {
      "perPage": 1,
      "autoplay": true
    }
  }, [_c('slide', {
    class: _vm.$style.slide
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(17),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    class: _vm.$style.sliderText
  }, [_vm._v("\n                Útilegumannabyggð, hellir og minjar af skjóli úr steinum og steyptum veggjum, , fannst við gamla gönguleið nálægt Eldvörpum þegar Hitaveita Suðurnesja var að bora þar árið 1982? "), _c('strong', {
    class: _vm.$style.tag
  }, [_vm._v("#goðarsogur")])])]), _vm._v(" "), _c('slide', {
    class: _vm.$style.slide
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(18),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    class: _vm.$style.sliderText
  }, [_vm._v("\n                Aðeins 8 sjómílur suður af Reykjanesi er þverhnípta klettaeyjan Eldey? Eitt skerjanna í klasanum er svokallað Geirfuglasker en þar hélt geirfuglinn síðast til. Eldey er einnig stærsta súlubyggð í heiminum! "), _c('strong', {
    class: _vm.$style.tag
  }, [_vm._v("#goðarsogur")])])]), _vm._v(" "), _c('slide', {
    class: _vm.$style.slide
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(19),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    class: _vm.$style.sliderText
  }, [_vm._v("\n                Suður í Krýsuvík er þyrping sprengigíga og einn sá þekktasti er í raun lítið stöðuvatn sem ber heitið Grænavatn? Gígurinn er yfir 6000 ára gamall og vatnið er farið að mygla. Grín! Græni liturinn er kominn til vegna samblöndunar brennisteinstegunda. "), _c('strong', {
    class: _vm.$style.tag
  }, [_vm._v("#goðarsogur")])])]), _vm._v(" "), _c('slide', {
    class: _vm.$style.slide
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(20),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    class: _vm.$style.sliderText
  }, [_vm._v("\n                Sogin eru 150 til 200 metra djúp vatnssorfin leirgil og hryggir?  Mikill hiti frá háhitahverum á svæðinu útskýrir litadýrðina sem einkennir þetta sérkennilega háhitasvæði sunnan Trölladyngju og Grænudyngju, skammt frá Keili. "), _c('strong', {
    class: _vm.$style.tag
  }, [_vm._v("#goðarsogur")])])]), _vm._v(" "), _c('slide', {
    class: _vm.$style.slide
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(21),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    class: _vm.$style.sliderText
  }, [_vm._v("\n                Brennisteinsfjöll eru stór þyrping móbergsfjalla frá síðari hluta ísaldar? Í norðanverðum Brennisteinsfjöllum er háhitasvæði og í kringum 1880 voru þar brennisteinsnámur sem enn má koma auga á. "), _c('strong', {
    class: _vm.$style.tag
  }, [_vm._v("#goðarsogur")])])]), _vm._v(" "), _c('slide', {
    class: _vm.$style.slide
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(22),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    class: _vm.$style.sliderText
  }, [_vm._v("\n                Þetta er Brimketill. Hann er staðsettur rétt hjá Grindavík. Hann varð til vegna stöðugs núnings brims við hraunkatlana. Sundgarpar eiga það til að baða sig í honum, rétt eins og Oddný Nátttröll. Hún var þarna. Hefur þú prófað? "), _c('strong', {
    class: _vm.$style.tag
  }, [_vm._v("#goðarsogur")])])]), _vm._v(" "), _c('slide', {
    class: _vm.$style.slide
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(23),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    class: _vm.$style.sliderText
  }, [_vm._v("\n                Rétt austan við Reykjanesvita er stórbrotið jarðhitasvæði? Þar er Gunnuhver, sem dregur nafn sitt af Guðrúnu nokkurri sem gekk aftur og olli miklum usla á svæðinu. Presturinn Eiríkur Magnússon kom draugsa fyrir kattarnef er hann sendi hann í einn hveranna. Langar þig að hitta Gunnu? "), _c('strong', {
    class: _vm.$style.tag
  }, [_vm._v("#goðarsogur")])])])], 1)], 1)])]), _vm._v(" "), _c('h2', {
    class: [_vm.$style.title, _vm.$style.titleLarge]
  }, [_vm._v("Vinningsmyndir")]), _vm._v(" "), _c('winners')], 1)
},staticRenderFns: []}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.header
  }, [_c('div', {
    class: _vm.$style.header__inner
  }, [_c('div', {
    class: _vm.$style.header__logo
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(16)
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.tagplayContainer
  }, [_c('div', {
    class: _vm.$style.columns
  }, _vm._l((_vm.posts), function(post) {
    return _c('div', {
      class: _vm.$style.column
    }, [_c('div', {
      staticClass: "tagplay-media-container tagplay-media-instagram"
    }, [_c('div', {
      staticClass: "tagplay-media-inner"
    }, [_c('p', {
      staticClass: "tagplay-media-username"
    }, [_c('a', {
      attrs: {
        "href": ("https://instagram.com/" + (post.username)),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(post.username))])]), _vm._v(" "), _c('div', {
      staticClass: "tagplay-media"
    }, [_c('a', {
      staticClass: "tagplay-media-link",
      attrs: {
        "href": ("https://www.instagram.com/p/" + (post.post) + "/"),
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "tagplay-media-object",
      attrs: {
        "src": ("https://instagram.com/p/" + (post.post) + "/media/?size=l")
      }
    })])]), _vm._v(" "), _c('p', {
      staticClass: "tagplay-media-text"
    }, [_c('strong', [_vm._v("Ljósmyndari:")]), _c('br'), _vm._v("\n          " + _vm._s(post.name)), _c('br'), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Verðlaun:")]), _c('br'), _vm._v("\n          " + _vm._s(post.prize) + "\n        ")])])])])
  }))])
},staticRenderFns: []}

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.tagplayContainer
  }, [_c('div', {
    staticClass: "tagplay-widget",
    attrs: {
      "id": "tagplay-widget-1c6bd9",
      "data-project": "04d7b70a-aaa4-4c51-9c0b-78f12c0c98ce",
      "data-feed": "1c6bd967-1cd7-4be7-a512-ad651683f011",
      "data-token": "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJlbWFpbCI6ImVpbmFyQHNpbGZyYS5pcyIsImFwaV9rZXkiOiJhOGJkY2NmNmE0NWUzMWI4MTA1NzY0ZGQyMjYwNmZkZTMxNzYwNjRlIiwiZmVlZElkIjoiMWM2YmQ5NjctMWNkNy00YmU3LWE1MTItYWQ2NTE2ODNmMDExIiwiaWF0IjoxNDk0NDIzMTg1fQ.AZz4jX968CTcL25Ir_59P1flaSgmc0qzuIbTW7HgAMI",
      "data-include-usernames": "",
      "data-include-captions": "",
      "data-include-link-metadata": "",
      "data-rows": "120",
      "data-cols": _vm.cols,
      "data-spacing": "10",
      "data-hashtags": "show",
      "data-style": "minimal",
      "data-type": "grid",
      "data-responsive": "",
      "data-lightbox": "",
      "data-trigger-tags": "góðarsögur,godarsogur",
      "data-num-media": "360",
      "data-client": "[object Object]"
    }
  })])
},staticRenderFns: []}

/***/ })
],[9]);


// WEBPACK FOOTER //
// static/js/app.edb41521c3600b5aab69.js